import React from 'react';
import useScrollReveal from '../hooks/useScrollReveal';

/**
 * Wrap children with a scroll-triggered fade/slide animation.
 * variant: 'up' | 'left' | 'right' | 'scale'
 * delay: ms
 */
export default function Reveal({ children, variant = 'up', delay = 0, className = '' }) {
  const [ref, visible] = useScrollReveal();

  const initial = {
    up:    'translate3d(0, 24px, 0)',
    left:  'translate3d(-24px, 0, 0)',
    right: 'translate3d(24px, 0, 0)',
    scale: 'scale(0.96)',
  }[variant];

  return (
    <div
      ref={ref}
      className={className}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'translate3d(0,0,0) scale(1)' : initial,
        transition: `opacity 700ms ease-out ${delay}ms, transform 700ms ease-out ${delay}ms`,
        willChange: 'transform, opacity',
      }}
    >
      {children}
    </div>
  );
}
